// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hViCg","largestCol":"styles_largestCol__3CSIu","smallestCol":"styles_smallestCol__3RJvj"};